import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
import { DxBaseUiOptions } from "../../../../dx-page-markup/domain/ui-options/dx-base-ui-options";
/**
 * Опции верхнего меню навигатора.
 * @publicApi
 */
let DxHeadNavigationMenuOptions = class DxHeadNavigationMenuOptions extends DxBaseUiOptions {
    /**
     * Опции верхнего меню навигатора.
     * @publicApi
     */
    constructor() {
        super(...arguments);
        this._showHomeBtn = true;
        this._useCarousel = true;
        this._maxCountOfDisplayedItems = 7;
    }
    get homeBtnIcon() {
        return this._homeBtnIcon;
    }
    set homeBtnIcon(value) {
        this._homeBtnIcon = value;
    }
    get showHomeBtn() {
        return this._showHomeBtn;
    }
    set showHomeBtn(value) {
        this._showHomeBtn = value;
    }
    get useCarousel() {
        return this._useCarousel;
    }
    get prevBtnIcon() {
        return this._prevBtnIcon;
    }
    set prevBtnIcon(value) {
        this._prevBtnIcon = value;
    }
    get nextBtnIcon() {
        return this._nextBtnIcon;
    }
    set nextBtnIcon(value) {
        this._nextBtnIcon = value;
    }
    set useCarousel(value) {
        this._useCarousel = value;
    }
    get maxCountOfDisplayedItems() {
        return this._maxCountOfDisplayedItems;
    }
    set maxCountOfDisplayedItems(value) {
        this._maxCountOfDisplayedItems = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "showHomeBtn", constructor: Boolean, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxHeadNavigationMenuOptions.prototype, "_showHomeBtn", void 0);
tslib_1.__decorate([
    jsonMember({ name: "homeBtnIcon", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxHeadNavigationMenuOptions.prototype, "_homeBtnIcon", void 0);
tslib_1.__decorate([
    jsonMember({ name: "useCarousel", constructor: Boolean, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxHeadNavigationMenuOptions.prototype, "_useCarousel", void 0);
tslib_1.__decorate([
    jsonMember({ name: "prevBtnIcon", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxHeadNavigationMenuOptions.prototype, "_prevBtnIcon", void 0);
tslib_1.__decorate([
    jsonMember({ name: "nextBtnIcon", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxHeadNavigationMenuOptions.prototype, "_nextBtnIcon", void 0);
tslib_1.__decorate([
    jsonMember({ name: "maxCountOfDisplayedItems", constructor: Number, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxHeadNavigationMenuOptions.prototype, "_maxCountOfDisplayedItems", void 0);
DxHeadNavigationMenuOptions = tslib_1.__decorate([
    jsonObject
], DxHeadNavigationMenuOptions);
export { DxHeadNavigationMenuOptions };
